import React, { Component } from 'react';
import $ from 'jquery';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import {notify} from 'react-notify-toast';
import {Row,Col} from 'react-bootstrap';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';

class Add extends Component{
	constructor(props){
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'SAVE UNIVERSITY',
			isRedirect: false,
			showLoader: false,
			showAddModal: false,
			country: '',
			region: ''
		}
		
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

	selectCountry (val) {
		this.setState({ country: val });
	}
	 
	selectRegion (val) {
		this.setState({ region: val });
	}
	
	handleFormSubmit(e){
		e.preventDefault();
		this.setState({showLoader:true,saveText:'Saving..'});
		var formData = Sanitize.objectifyForm($("#frmAdd").serializeArray());
		Reqst.axPost('university/saveuniversity',{token: Reqst.Token(formData)}).then(res=>{
			if(res['data'].status=='1')
			{
				document.getElementById("frmAdd").reset();
				notify.show(res['data'].msg,'success');
				this.setState({showLoader:false,saveText:'SAVE UNIVERSITY'});
				if(this.props.afterFinish) this.props.afterFinish();
			}
			else
			{
				notify.show(res['data'].msg,'error');
				this.setState({showLoader:false,saveText:'SAVE UNIVERSITY'});
			}
		});
	}
	
	render(){
		
		const { country, region } = this.state;

		return(
			<div>			
				<form action="" method="post" encType="multipart/form-data" id="frmAdd" onSubmit={this.handleFormSubmit} >
					<input type="hidden" name="i__lid" value={this.state.loginId} />
					<input type="hidden" name="i__company" value={this.state.companyId} />
					<input type="hidden" name="i__master" value={this.state.masterId} />
					<Row>
						<Col md={12} >
							<label>University Name <span className="text-danger">*</span></label>
							<input type="text" name="i__name" id="i__name" className="form-control input-sm" required />
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<label>City </label>
							<input type="text" name="i__city" id="i__city" className="form-control input-sm" />
						</Col>
					</Row>
					<Row>
						<Col md={12}>
							<label>Country</label>
							<CountryDropdown className="form-control input-sm"  value={country} onChange={(val) => this.selectCountry(val)} />
						</Col>
					</Row>
					<Row>
						<Col md={12}>
							<label>State</label>
							<RegionDropdown className="form-control input-sm"  country={country} value={region} onChange={(val) => this.selectRegion(val)} />
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<label>Contact No </label>
							<input type="text" name="i__mobile" id="i__mobile" onKeyPress={Sanitize.integerIndMobile} className="form-control input-sm" />
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<label>Active Status <span className="text-danger">*</span></label>
							<select name="i__status" id="i__status" className="form-control input-sm" required >
								<option value="1"> Active </option>
								<option value="0"> In Active </option>
							</select>
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<br />
							<div className="text-right" >
								<button type="submit" className="btn btn-info btn-sm btn-success_2" disabled={this.state.saveText!='SAVE UNIVERSITY'} >
									<i className="fa fa-check"></i> {this.state.saveText} 
								</button>
							</div>
						</Col>
					</Row>
				</form>
			</div>
		);
	}
	
}
export default Add;